import gsap from"gsap";
import{ ScrollTrigger }from"gsap/ScrollTrigger";
import{ innerH, isMobile }from"./utils/variables";

export function runDefaultAt(path: string){
    import(`${path}`).then((imp) => imp.default());
}

export function ifModuleThenImport(el: string, path: string, onEnter: boolean){
    const element = document.querySelector(el);

    if(element){
        if(onEnter && !isMobile){
            gsap.to(element, {
                scrollTrigger: {
                    trigger: element,
                    start: `top bottom+=${innerH}`,
                    once: true,

                    onEnter: () => {
                        runDefaultAt(`./modules/${path}`);
                        ScrollTrigger.refresh();
                    }
                }
            });

        }else runDefaultAt(`./modules/${path}`);

    }
}